import React, { useEffect, useState } from "react";
import { Table, Spinner, Card } from "react-bootstrap";
import { horizon } from "../api/horizon"; // Assuming API functions are defined here
import { usePageMetadata } from "../context/PageMetadataContext";
import { Link } from "react-router-dom";
import CopyIcon from "../components/CopyIcon";
import { okx } from "../api/okx";
import { CardContent } from "../components/Card";
import { coreTeamAddress, LabledAddress } from "../utils/addresss";
import AccountLabel from "../components/AccountLabel";
// import AdUnit from "../components/AdUnit";
import { useLanguage } from "../context/LanguageContext";
import AdSenseUnit from "../components/AdsenseUnit";
import AdUnit from "../components/AdUnit";

const CexStatistics = () => {
  const { t, language } = useLanguage();
  
  interface CexBalance {
    Address: string;
    Rank: number;
    Url: string;
    SignUp: string;
    Logo: string;
    Name: string;
    Balance: number;
  }

  const [cexBalances, setCexBalances] = useState<CexBalance[]>([]);
  interface TeamBalance {
    Address: string;
    Balance: number;
  }
  
  const [teamsBalances, setTeamsBalances] = useState<TeamBalance[]>([]);
  const [loading, setLoading] = useState(false);
  const [piPriceUSD, setPiPriceUSD] = useState(0.0);
const {setHeading,setTitle,setDescription} = usePageMetadata();
  useEffect(() => {
    setHeading(t('cex.heading'));
    setTitle(t('cex.title'));
    setDescription(t('cex.description'));
  }, [setTitle, setDescription, setHeading, t, language]);
  // Fetch Pi price (Assuming there's an endpoint for this, otherwise set a static value)
  const fetchPiPrice = async () => {
    try {
      okx.getMarketData().then(marketData=>{
            // Market Stats
            setPiPriceUSD(parseFloat(marketData.idxPx));
      })
      
    } catch (error) {
      console.error("Error fetching Pi price:", error);
    }
  };

  // Fetch CEX balances using the provided API
  const fetchCexBalances = async () => {
    try {
      setLoading(true);
      horizon.getCexData().then((dataCexs) => {
        return setCexBalances(dataCexs);
      })
    } catch (error) {
      console.error("Error fetching CEX balances:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchTeamBalances = async () => {
    try {
      setLoading(true);
      horizon.getBalances(coreTeamAddress).then((balances) => {
        return setTeamsBalances(balances);
      })
    } catch (error) {
      console.error("Error fetching CEX balances:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPiPrice();
  }, []);

  useEffect(() => {
    if (piPriceUSD) {
    fetchCexBalances();
    fetchTeamBalances();
    }
  }, [piPriceUSD]);

  // Format number according to user locale
  const formatNumber = (value: number): string => {
    return value.toLocaleString(language, {  
      minimumFractionDigits: 0,  
      maximumFractionDigits: 2 
    });
  };

  // Format currency according to user locale
  const formatCurrency = (value: number): string => {
    return value.toLocaleString(language, {  
      minimumFractionDigits: 0,  
      maximumFractionDigits: 2 
    });
  };

  return (
    <div className="">
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="primary" />
          <p className="ms-2">{t('common.loading')}</p>
        </div>
      ) : (
        <div>
            <div className="col-md-12">
                <Card className="none-radius">
                    <CardContent>
                        <h5 className="card-title" style={{fontSize:"16px",marginBottom:"20px"}}>{t('cex.wallet_balances')}</h5>
                        <Table hover responsive className="cex-table">
                        <thead>
                            <tr>
                            <th>{t('cex.cmc_ranking')}</th>
                            <th>{t('cex.exchange')}</th>
                            <th>{t('cex.chart_link')}</th>
                            <th>{t('cex.signup_link')}</th>
                            <th>{t('cex.wallet_address')}</th>
                            <th>{t('cex.balance_pi')}</th>
                            <th>{t('cex.balance_usd')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cexBalances.map((cex, index) => (
                            <tr key={index}>
                                <td>{cex.Rank}</td>
                                <td>
                                <a href={cex.SignUp} target="_blank" rel="noreferrer" className="text-decoration-none">
                                <img src={cex.Logo} alt={cex.Name} className="cex-logo" width={20} />
                                {" "}
                                <span className="cex-name">{cex.Name}</span>
                                </a>
                                </td>
                                <td>
                                  <a 
                                    href={cex.Url} 
                                    target="_blank" 
                                    rel="noreferrer" 
                                    className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                                  >
                                    <i className="bi bi-graph-up me-1"></i> {t('cex.chart')}
                                  </a>
                                </td>
                                <td>
                                  <a 
                                    href={cex.SignUp} 
                                    target="_blank" 
                                    rel="noreferrer" 
                                    className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                                  >
                                    <i className="bi bi-person-plus me-1"></i> {t('cex.signup')}
                                  </a>
                                </td>
                                
                                <td>
                                <Link className="text-decoration-none" to={`/account/${cex.Address}`}>
                                    {cex.Address.slice(0,8)}...{cex.Address.slice(-5)}
                                </Link>{" "} <CopyIcon textToCopy={cex.Address}/>
                                </td>
                                
                                
                                <td>{formatNumber(cex.Balance)}</td>
                                <td>${formatCurrency(cex.Balance * piPriceUSD)}</td>
                            </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr style={{fontWeight:"600"}}>
                            <td colSpan={5}>{t('cex.total')}</td>
                            <td>{formatNumber(cexBalances.reduce((a, b) => a + b.Balance, 0))}</td>
                            <td>${formatCurrency(cexBalances.reduce((a, b) => a + b.Balance, 0) * piPriceUSD)}</td>
                            </tr>
                        </tfoot>
                        </Table>
                    </CardContent>
                </Card>
            </div>
             
            <div className="row g-3 mb-4  d-block d-md-none">
        {/* <AdSenseUnit/> */}
        {/* <AdUnit
                  className="67cca9819302154e82f055f8"
                  width="300px"
                  height="100px"
                  centered={true}
                /> */}
      </div>
      
        <div className="col-md-12" style={{marginTop: "20px"}}>
          <Card className="none-radius">
              <CardContent>
              <h5 className="card-title" style={{fontSize:"16px",marginBottom:"20px"}}>{t('cex.core_team_wallets')}</h5>
                <Table hover responsive className="cex-table">
                <thead>
                    <tr>
                    <th>#</th>
                    <th>{t('cex.note')}</th>
                    <th>{t('cex.wallet_address')}</th>
                    <th>{t('cex.balance_pi')}</th>
                    <th>{t('cex.balance_usd')}</th>
                    </tr>
                </thead>
                <tbody>
                    {teamsBalances.map((item, index) => (
                    <tr key={index}>
                        <td>{index}</td>
                        <td>
                        
                        <span className="cex-name">{LabledAddress[item.Address]!=null?LabledAddress[item.Address].Name:""}</span>
                        
                        </td>
                        <td>
                        <Link className="text-decoration-none" to={`/account/${item.Address}`}>
                        {item.Address.slice(0,8)}...{item.Address.slice(-5)}
                        </Link>
                        {" "}<CopyIcon textToCopy={item.Address} />
                        </td>
                        <td>{formatNumber(item.Balance)}</td>
                        <td>${formatCurrency(item.Balance * piPriceUSD)}</td>
                    </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr style={{fontWeight:"600"}}>
                    <td colSpan={1}>{t('cex.total')}</td>
                    <td colSpan={2} style={{fontWeight:400}}><i>{t('cex.team_wallet_footnote')}</i></td>
                    <td>{formatNumber(teamsBalances.reduce((a, b) => a + b.Balance, 0))}</td>
                    <td>${formatCurrency(teamsBalances.reduce((a, b) => a + b.Balance, 0) * piPriceUSD)}</td>
                    </tr>
                </tfoot>
                </Table>
                </CardContent>
            </Card>
        </div>
       
        </div>
      )}
    </div>
  );
};

export default CexStatistics;
